import React from "react";
import Scan from "../../components/Scan/Scan";
import useTabs from "../../hooks/useTabs";
import useValidation from "../../hooks/useValidation";
import { ISearchUser } from "../../store/types/userTypes";

const ToScan = () => {
  const { addTabWithStore, autoChangeTab } = useTabs();
  const { isLoadUserTab } = useValidation();

  const onSubmit = (result: ISearchUser) => {
    isLoadUserTab(result).then((response) => {
      if (response.isLoad) {
        autoChangeTab(response.tabIndex);
      } else {
        addTabWithStore(result, { eventType: "in" });
      }
    });
  };

  return <Scan onScan={onSubmit} />;
};

export default ToScan;
